import { useMutation } from '@biletiniz/apollo';
import { RESEND_CODE } from './gql/resend-code';

export const useResendCode = () => {
  const [resendCodeMutation, { error, loading }] = useMutation(RESEND_CODE);

  const resendCode = resendCodeInfo => {
    return resendCodeMutation({
      variables: resendCodeInfo,
    });
  };

  return {
    error: error?.message,
    resendCode,
    loading,
  };
};
